import React, { Suspense, lazy, useState } from 'react';
import { useLanguage } from '../../contexts/LanguageContext';

const SellingLandModal = lazy(() => import('../SellingLandModal'));

const MonitorLandCTA = () => {
  const { t } = useLanguage();
  const [showSellingModal, setShowSellingModal] = useState(false);
  const [isClosing, setIsClosing] = useState(false);

  const handleCloseModal = () => {
    if (isClosing) return;
    console.log('[MonitorLandCTA] Close requested via button/backdrop');
    setIsClosing(true);
  };

  const handleCloseAnimationComplete = () => {
    console.log('[MonitorLandCTA] Close animation completed, unmounting modal');
    setShowSellingModal(false);
    setIsClosing(false);
  };

  return (
    <>
      <div className="max-w-7xl mx-auto px-4 py-8 sm:py-10 md:py-12 font-montserrat">
        <div className="bg-gradient-to-br from-blue-50 to-green-50 rounded-3xl p-8 sm:p-10 md:p-10 lg:p-12 border-2 border-brand-green/30 text-center">
          <div className="max-w-3xl mx-auto">
            <h2 className="text-3xl sm:text-4xl md:text-4xl font-bold mb-4 sm:mb-5 text-gray-800">
              {t('monitorCTA.title')}
            </h2>

            <p className="text-gray-600 mb-6 sm:mb-8 text-base sm:text-lg md:text-xl leading-relaxed">
              {t('monitorCTA.description')}
            </p>

            <button
              onClick={() => setShowSellingModal(true)}
              className="inline-flex items-center px-8 py-4 rounded-lg bg-brand-green text-white text-lg font-semibold hover:bg-green-700 transition-all shadow-lg hover:shadow-xl transform hover:-translate-y-0.5"
            >
              {t('monitorCTA.button')}
            </button>
          </div>
        </div>
      </div>

      {(showSellingModal || isClosing) && (
        <Suspense fallback={null}>
          <SellingLandModal
            isOpen={showSellingModal}
            onClose={handleCloseModal}
            onCloseComplete={handleCloseAnimationComplete}
            isClosing={isClosing}
          />
        </Suspense>
      )}
    </>
  );
};

export default MonitorLandCTA;
